import { useMemo } from 'react'
import type { User } from 'firebase/auth'
import type { Group } from '../types'

const EMPTY_IDS: string[] = []

// People whose interests the current user can see on shared surfaces: everyone
// who shares a group with them (existing behavior) unioned with their explicit
// accepted friends (independent of any shared group).
export function useFriendIds(
  user: User | null,
  groups: Group[],
  explicitFriendIds: string[] = EMPTY_IDS,
): string[] {
  return useMemo(() => {
    if (!user) return EMPTY_IDS
    const set = new Set<string>()
    for (const g of groups) for (const id of g.memberIds) if (id !== user.uid) set.add(id)
    for (const id of explicitFriendIds) if (id !== user.uid) set.add(id)
    return [...set]
  }, [groups, user, explicitFriendIds])
}
